import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import IhrExperteFuerHochdruckreinigungUndGartenpflegeInHavixbe from "./sections/IhrExperteFuerHochdruckreinigungUndGartenpflegeInHavixbe";
import UnsereUmweltfreundlichenLeistungen from "./sections/UnsereUmweltfreundlichenLeistungen";
import HighPressureAndStoneCleaningEnvironmentallyFriendly from "./sections/HighPressureAndStoneCleaningEnvironmentallyFriendly";
import GardenCareForAWellMaintainedOutdoorArea from "./sections/GardenCareForAWellMaintainedOutdoorArea";
import PropertyManagementReliableAndComprehensive from "./sections/PropertyManagementReliableAndComprehensive";
import WhyChooseUs from "./sections/WhyChooseUs";
import BeforeAfterGallery from "./sections/BeforeAfterGallery";
import Footer from "@/reusable_sections/Footer";
import Seometa from "./sections/Seometa";
export default function HomePage() {
  return <div>
      <Seometa />
      <Header />
      <IhrExperteFuerHochdruckreinigungUndGartenpflegeInHavixbe />
      <UnsereUmweltfreundlichenLeistungen />
      <HighPressureAndStoneCleaningEnvironmentallyFriendly />
      <GardenCareForAWellMaintainedOutdoorArea />
      <PropertyManagementReliableAndComprehensive />
      <WhyChooseUs />
      <BeforeAfterGallery />
      <Footer />
    </div>;
}